
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiImage as ObiImageElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-image.js';
 
 
 

 
 export const ObiImage = createComponent({
   react: React,
   tagName: 'obi-image',
   elementClass: ObiImageElement,
   events: {
     
   }
  });
 
 